<template>
  <span class="icon-button" :title="tooltip" @click="$emit('click')">
    <icon :name="icon" :color="color" />
  </span>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "primary",
    },
  },
  emits: ["click"],
};
</script>
<style lang="scss" scoped>
.icon-button {
  display: inline-block;
  cursor: pointer;
}
</style>
